"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FallbackNode = exports.isFallbackNode = exports.isValidFallbackField = exports.FallbackFields = void 0;
exports.makeFallback = makeFallback;
const localization_1 = require("./localization");
const class_1 = require("./class");
const utils_1 = require("../utils");
const base_1 = require("./base");
const filters_1 = require("./filters");
/**
 * Define all allowed `fallback` attributes:
 * `dir`, `xml:lang`, `translate`, `props`, `class`, `outputclass`
 */
exports.FallbackFields = [...localization_1.LocalizationFields, ...filters_1.FiltersFields, ...class_1.ClassFields];
/**
 * Check if the given attributes of the `fallback` node are valid
 *
 * @param field - A string containing the name of the attributes
 * @param value - A BasicValue-typed value containing the attributes value
 * @returns Boolean
 */
const isValidFallbackField = (field, value) => (0, localization_1.isValidLocalizationField)(field, value)
    || (0, filters_1.isValidFiltersField)(field, value)
    || (0, class_1.isValidClassField)(field, value);
exports.isValidFallbackField = isValidFallbackField;
/**
 * Check if the `fallback` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `fallback` node to test
 * @returns Boolean
 */
const isFallbackNode = (value) => typeof value === 'object' && !!value && (0, utils_1.areFieldsValid)(exports.FallbackFields, value, exports.isValidFallbackField);
exports.isFallbackNode = isFallbackNode;
/**
 * Construct a `fallback` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns A `fallback` node
 */
function makeFallback(constructor) {
    return (0, base_1.makeAll)(constructor, localization_1.makeLocalization, filters_1.makeFilters, class_1.makeClass);
}
/**
 * Create a `fallback` node (Fallback)
 *
 * @decorator `@makeComponent`
 * @param makeFallback - The `fallback` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidFallbackField - A boolean value, if the attribute is valid or not
 * @param fields - A List of valid attributes, @see {@link FallbackFields}
 * @param childNodes - An Array of allowed child nodes `image`,`alt`,`p`,`ul`,`ol`,`dl`,`pre`,`note`
 */
let FallbackNode = class FallbackNode extends base_1.AbstractBaseNode {
};
exports.FallbackNode = FallbackNode;
exports.FallbackNode = FallbackNode = __decorate([
    (0, base_1.makeComponent)(makeFallback, 'fallback', exports.isValidFallbackField, exports.FallbackFields, ['%fallback-blocks*'])
], FallbackNode);
//# sourceMappingURL=fallback.js.map